






























import { Component, Vue } from "vue-property-decorator";
import { deleteBackground, checkDelete } from "@/services/backgrounds/backgroundService";

@Component
export default class BackgroundDeleteModal extends Vue {
    backgroundToBeDeleted: string = "";
    backgroundName: string = ""
    isSaved: boolean = false;

    handleEnter(e: KeyboardEvent) {
        if (e.key === "Enter") {
            if (this.backgroundToBeDeleted !== "") this.confirm();
            else this.close();
        }
    }

    removeEvent() {
        window.removeEventListener("keydown", this.handleEnter);
        this.isSaved = false;
        this.backgroundToBeDeleted = "";
        this.backgroundName = "";
    }

    open(backgroundId: string, name: string) {
        checkDelete(backgroundId).then(response => {
            if (response) {
                this.backgroundToBeDeleted = backgroundId;
                this.backgroundName = name;
                this.$bvModal.show("modal-deleteBackground");
            } else {
                this.$bvModal.show("modal-deleteBackgroundNotAllowed");
            }

            window.addEventListener("keydown", this.handleEnter);
        });
    }

    close() {
        this.$bvModal.hide("modal-deleteBackgroundNotAllowed");
    }

    decline() {
        this.$bvModal.hide("modal-deleteBackground");
        this.backgroundToBeDeleted = "";
        this.backgroundName = "";
    }

    confirm() {
        if (this.isSaved) return;
        this.isSaved = true;
        deleteBackground(this.backgroundToBeDeleted).then(() => {
            this.$emit("reload");
            this.backgroundToBeDeleted = "";
            this.backgroundName = "";
            this.$bvModal.hide("modal-deleteBackground");
        });
    }
}
